import Keycloak from 'keycloak-js';

if (!window._env_) {
  throw new Error(
    'Runtime environment variables are not loaded. Ensure env-config.js is served correctly.'
  );
}

const KeycloakService = new Keycloak({
  url: window._env_.KC_URL,
  realm: window._env_.KC_REALM,
  clientId: window._env_.KC_CLIENT_ID
});

export default KeycloakService;
